import { Modal, Button, Tag, Divider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircle,
  faCircleCheck,
  faCreditCard,
  faEdit,
  faHome,
  faPencil,
  faPlaneDeparture,
} from "@fortawesome/free-solid-svg-icons";

const ConfirmModal = ({ visible, onClose, data, onOk }) => {
  if (!data) return null;

  const passengers = data?.ListPassenger || [];

  const formatPassengerType = (type) => {
    switch (type) {
      case "ADT":
        return <Tag color="orange">Người lớn</Tag>;
      case "CHD":
        return <Tag color="orange">Trẻ em</Tag>;
      case "INF":
        return <Tag color="orange">Em bé</Tag>;
      default:
        return <Tag>{type}</Tag>;
    }
  };

  return (
    <Modal
      open={visible}
      footer={null}
      onCancel={onClose}
      closable
      className="rounded-2xl repayment-modal"
    >
      <div>
        {/* Header */}
        <div className="bg-primary text-white p-3  text-left rounded-tl-md rounded-tr-md flex gap-4 items-center">
          <div className="w-[32px] h-[32px]  rounded-full bg-primary-light flex items-center justify-center">
            {" "}
            <FontAwesomeIcon icon={faCircleCheck} />
          </div>
          <div>
            <p className="font-semibold text-[16px]">Xác nhận thông tin</p>
            <p className="text-[14px]">
              Vui lòng kiểm tra kỹ trước khi thanh toán
            </p>
          </div>
        </div>
        <div className="p-3">
          {/* Hành khách */}
          <div className="mb-4">
            <div className="text-[14px] font-bold uppercase text-gray-500 mb-2">
              Hành khách
            </div>
            {passengers.map((p, idx) => (
              <div
                key={p.Index}
                className="flex items-center justify-between border border-solid p-2 rounded-lg mb-2 border-sky-100"
              >
                <div className="flex gap-2 items-center">
                  <div className="w-[32px] h-[32px] rounded-full bg-primary flex items-center justify-center text-center">
                    {" "}
                    <span className="font-semibold text-white">{idx + 1}</span>
                  </div>
                  <span>
                    {p.FirstName} {p.LastName}
                  </span>
                </div>
                {formatPassengerType(p.Type)}
              </div>
            ))}
          </div>

          {/* Liên hệ */}
          <div className="mb-4">
            <div className="text-[14px] font-bold uppercase text-gray-500 mb-2">
              Liên hệ
            </div>
            <div className="p-3 border rounded-lg bg-gray-50 mb-3 border-sky-100 border-solid">
              <p className="text-gray-500 text-xs">HỌ VÀ TÊN</p>
              <p className="font-semibold text-sm">
                {data.ContactFirstName + " " + data.ContactLastName}
              </p>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="p-3 border rounded-lg bg-gray-50 border-solid border-sky-100">
                <p className="text-gray-500 text-xs uppercase">Số điện thoại</p>
                <p className="font-semibold text-sm">{data.ContactPhone}</p>
              </div>
              <div className="p-3 border rounded-lg bg-gray-50 border-solid border-sky-100">
                <p className="text-gray-500 text-xs uppercase">Email</p>
                <p className="font-semibold text-sm">{data.ContactEmail}</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <Divider />
          <div className="flex justify-center gap-4">
            <Button onClick={onClose} size="large" className="w-1/2">
              {" "}
              <FontAwesomeIcon icon={faEdit} />
              <span className="text-gray-500">Chỉnh sửa</span>
            </Button>
            <Button
              type="primary"
              size="large"
              className="w-1/2"
              onClick={onOk}
            >
              <FontAwesomeIcon icon={faCreditCard} />
              Thanh toán
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
